import actionTypes from './actionTypes';
import * as menuUtils from '../utils/menuUtils';

const getMenuRequest = () => ({
  type: actionTypes.GET_MENU_REQUEST
});

const getMenuSuccess = (res) => ({
  type: actionTypes.GET_MENU_SUCCESS,
  res
});

const getMenuFailure = (error) => ({
  type: actionTypes.GET_MENU_FAILURE,
  error
});

export const getMenu = (filter) => {
  return async (dispatch) => {
    try {
      dispatch(getMenuRequest());
      let res = await menuUtils.getMenu(filter);
      dispatch(getMenuSuccess(res));
    } catch(error) {
      dispatch(getMenuFailure(error));
    }
  }
}
